import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Input } from '@/components/ui/input';
import { Send, Loader2, Trash2 } from 'lucide-react';
import PlanLimitTooltip from '@/components/PlanLimitTooltip';

export function TOCMessageDialog({
  open,
  onOpenChange,
  schoolName,
  conversation,
  messageText,
  setMessageText,
  onSendMessage,
  onDeleteMessage,
  isSending,
  userId,
  sendDisabled = false,
  disabledMessage
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-lg max-h-[80vh] flex flex-col">
        <DialogHeader>
          <DialogTitle className="font-['Manrope']">Message {schoolName}</DialogTitle>
        </DialogHeader>
        
        <div className="flex-1 overflow-y-auto space-y-3 py-4 max-h-64">
          {conversation.length === 0 ? (
            <p className="text-center text-slate-500 text-sm py-8">
              No messages yet. Start the conversation!
            </p>
          ) : (
            conversation.map((msg) => (
              <div 
                key={msg.message_id}
                className={`p-3 rounded-lg ${
                  msg.sender_id === userId 
                    ? 'bg-emerald-600 text-white ml-8' 
                    : 'bg-slate-100 text-slate-900 mr-8'
                }`}
              >
                <p className="text-sm">{msg.content}</p>
                <div className="flex items-center justify-between mt-1">
                  <p className={`text-xs ${msg.sender_id === userId ? 'text-emerald-200' : 'text-slate-500'}`}>
                    {new Date(msg.created_at).toLocaleString()}
                  </p>
                  {msg.sender_id === userId && onDeleteMessage && (
                    <button 
                      onClick={() => onDeleteMessage(msg.message_id)}
                      className={`text-xs opacity-60 hover:opacity-100 ${msg.sender_id === userId ? 'text-emerald-200' : 'text-slate-500'}`}
                      title="Delete message"
                    >
                      <Trash2 className="h-3 w-3" />
                    </button>
                  )}
                </div>
              </div>
            ))
          )}
        </div>
        
        <div className="flex gap-2 pt-4 border-t">
          <Input
            value={messageText}
            onChange={(e) => setMessageText(e.target.value)}
            placeholder={sendDisabled ? "Messaging is unavailable. Contact your school admin for details." : "Type a message..."}
            onKeyDown={(e) => {
              if (e.key === 'Enter' && !e.shiftKey && !sendDisabled) onSendMessage();
            }}
            disabled={isSending || sendDisabled}
            data-testid="toc-message-input"
          />
          <PlanLimitTooltip
            onClick={onSendMessage}
            disabled={sendDisabled || isSending || !messageText.trim()}
            showTooltip={sendDisabled}
            audience="sub"
            message={disabledMessage}
            className="bg-emerald-600 hover:bg-emerald-700"
            data-testid="toc-send-message-btn"
          >
            {isSending ? <Loader2 className="h-4 w-4 animate-spin" /> : <Send className="h-4 w-4" />}
          </PlanLimitTooltip>
        </div>
      </DialogContent>
    </Dialog>
  );
}
